import { t } from 'ttag';

const getStepTitle = (key) => {
    switch (key) {
        case 'series':
            return t`Fahrzeugserie`;
        case 'basicModel':
            return t`Grundmodell`;
        case 'engine':
            return t`Motorisierung`;
        case 'paintwork':
            return t`Lackierung`;
        case 'interior':
            return t`Innenraum`;
        case 'package':
        case 'packs':
            return t`Pakete`;
        case 'basicVehicle':
        case 'basicvehicle':
            return t`Sonderausstattung Basisfahrzeug`;
        case 'optionalEquipment':
        case 'lastrada':
            return t`Sonderausstattungen La Strada`;
        case 'conclusion':
            return t`Zusammenfassen & Speichern`;
        default:
            return null;
    }
};

export default getStepTitle;
